/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Edu_Chat_Input_Chip2_LabelInputs */



/**
* | output |
* | --- |
* | "How do I add a file to one message?" |
*
* @param {Uno_Edu_Chat_Input_Chip2_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_edu_chat_input_chip2_label = /** @type {((inputs?: Uno_Edu_Chat_Input_Chip2_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Edu_Chat_Input_Chip2_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Wie füge ich einer Nachricht eine Datei hinzu?")
	return /** @type {LocalizedString} */ ("How do I add a file to one message?")
});